import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text, ActionLink, stickyStyle, stickyHeader } from '@custom-components';
import LocaleLink from '../../../../components/LocaleLink';
import { OverflowContainer, PulseWrapper } from '../List.styles';
import { customerShape } from '../helperFunctions';

const resolveStatus = (status) => {
  const statusLookup = [
    {
      label: 'Pending Approval',
      value: 'PendingApproval'
    },
    {
      label: 'Active',
      value: 'Active'
    },
    {
      label: 'Declined',
      value: 'Declined'
    },
    {
      label: 'Disabled',
      value: 'Disabled'
    }
  ];

  const statusLabel = statusLookup.find((item) => item.value === status);
  return statusLabel ? statusLabel.label : '—';
};

class SupplierTable extends PureComponent {
  resolveMessages = () => {
    const { messages } = this.props;
    return { ...SupplierTable.defaultProps.messages, ...messages };
  };

  renderRows = () => {
    const { data } = this.props;

    if (!data) return null;

    return data.map((supplier) => {
      const { id, name, bookings, contactEmail, numAdmins, status, autoApproveMembers, domain } = supplier;
      const autoApproveSetting = autoApproveMembers ? 'ON' : 'OFF';

      return {
        id,
        name: (
          <div>
            <Text.CopyBody tagName="span">{name}</Text.CopyBody>
          </div>
        ),
        contact: (
          <div>
            <Text.CopyBody tagName="span">{contactEmail}</Text.CopyBody>
          </div>
        ),
        status: <Text.CopyBody>{resolveStatus(status)}</Text.CopyBody>,
        autoApproveMembers: <Text.CopyBody>{domain ? autoApproveSetting : '—'}</Text.CopyBody>,
        bookings: <Text.CopyBody>{bookings}</Text.CopyBody>,
        numAdmins: <Text.CopyBody>{numAdmins}</Text.CopyBody>,
        actionLink: (
          <LocaleLink route="CustomerOverview" params={{ customerId: id.toString() }}>
            <ActionLink>
              <Text.HeadingSixth noMargins>View Details</Text.HeadingSixth>
            </ActionLink>
          </LocaleLink>
        )
      };
    });
  };

  render() {
    const {
      organizationNameLabel,
      primaryContactLabel,
      bookingsNumLabel,
      adminsNumLabel,
      actionHeaderLabel,
      statusLabel,
      autoApproveMembersLabel
    } = this.resolveMessages();
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            headerCellsConfig={{ actionLink: { style: stickyHeader } }}
            contentCellsConfig={{ actionLink: { style: stickyStyle } }}
            rows={[
              { id: 'name', label: organizationNameLabel },
              { id: 'contact', label: primaryContactLabel },
              { id: 'status', label: statusLabel },
              { id: 'autoApproveMembers', label: autoApproveMembersLabel },
              { id: 'bookings', label: bookingsNumLabel },
              { id: 'numAdmins', label: adminsNumLabel },
              { id: 'actionLink', label: actionHeaderLabel }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }
}

SupplierTable.propTypes = {
  data: PropTypes.arrayOf(customerShape).isRequired,
  messages: PropTypes.shape({})
};

SupplierTable.defaultProps = {
  messages: {
    organizationNameLabel: 'Organization Name',
    primaryContactLabel: 'Primary Email',
    bookingsNumLabel: 'Properties',
    adminsNumLabel: 'Admins',
    actionHeaderLabel: '',
    statusLabel: 'Status',
    autoApproveMembersLabel: 'Auto Approve Users'
  }
};

export default SupplierTable;
